import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import LoginPage from './screens/login/LoginPage';
import NotFound from './components/NotFound';
import PrivateRoute from './components/PrivateRoute';
import ListAccountPage from './screens/mana-account/ListAccountPage';
import ListDepartmentPage from './screens/department/ListDepartmentPage';
import ListOrderPage from './screens/order/ListOrderPage';
import { useSelector } from 'react-redux';
import ReportOrderByShop from './screens/report/ReportOrderByShop';
import ChangePassPage from './screens/changepass/ChangePassPage';
import ListShopPage from './screens/shop/ListShopPage';
import DashboardPage from './screens/dashboard/DashboardPage';
import AuthenTiktokShopPage from './screens/shop/authen/AuthenTiktokShopPage';
import ListSuppilerPage from './screens/suppiler/ListSuppilerPage';
import ImportDataSku from './screens/sku/ImportDataSku';
import DataSkuPage from './screens/sku/DataSkuPage';
import ImportBaseCostSKU from './screens/sku/ImportBaseCostSKU';
import ReportOrderBySellers from './screens/report/ReportOrderBySellers';
import ReportTop10SellerPage from './screens/report/ReportTop10SellerPage';


const AppRouter = () => {
    const userReducer = useSelector(state => state?.userReducer?.data);
    return (
        <BrowserRouter>
            <Routes>
                <Route path='*' element={<NotFound />} />
                <Route path="/dang-nhap" element={
                    <LoginPage />
                } />
                <Route path="/" element={
                    <PrivateRoute requiredRoles={[1,2,3,4,5,6]}>
                        <ListOrderPage />
                    </PrivateRoute>
                } />
                <Route path="/dashboard" element={
                    <PrivateRoute requiredRoles={[1,2,3,4,5,6]}>
                        <DashboardPage />
                    </PrivateRoute>
                } />
                <Route path="/account" element={
                    <PrivateRoute requiredRoles={[1]}>
                        <ListAccountPage />
                    </PrivateRoute>
                } />
                <Route path="/department" element={
                    <PrivateRoute requiredRoles={[1]}>
                        <ListDepartmentPage />
                    </PrivateRoute>
                } />
                <Route path="/supplier" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListSuppilerPage />
                    </PrivateRoute>
                } />
                <Route path="/orders" element={
                    <PrivateRoute requiredRoles={[1, 2, 6]}>
                        <ListOrderPage />
                    </PrivateRoute>
                } />
                
                <Route path="/bao-cao-order" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ReportOrderByShop />
                    </PrivateRoute>
                } />
                
                <Route path="/doi-mat-khau" element={
                    <PrivateRoute requiredRoles={[1, 2, 3, 4, 5]}>
                        <ChangePassPage />
                    </PrivateRoute>
                } />
                
                <Route path="/shop" element={
                    <PrivateRoute requiredRoles={[1]}>
                        <ListShopPage />
                    </PrivateRoute>
                } />
                <Route path="/authen" element={
                    <PrivateRoute requiredRoles={[1]}>
                        <AuthenTiktokShopPage />
                    </PrivateRoute>
                } />
                <Route path="/import-sku" element={
                    <PrivateRoute requiredRoles={[1,2]}>
                        <ImportDataSku />
                    </PrivateRoute>
                } />
                <Route path="/data-sku" element={
                    <PrivateRoute requiredRoles={[1,2]}>
                        <DataSkuPage />
                    </PrivateRoute>
                } />
                <Route path="/import-basecost" element={
                    <PrivateRoute requiredRoles={[1,2]}>
                        <ImportBaseCostSKU />
                    </PrivateRoute>
                } />
                <Route path="/report-order-by-seller" element={
                    <PrivateRoute requiredRoles={[1,2]}>
                        <ReportOrderBySellers />
                    </PrivateRoute>
                } />
                <Route path="/report-top10-seller" element={
                    <PrivateRoute requiredRoles={[1,2]}>
                        <ReportTop10SellerPage />
                    </PrivateRoute>
                } />
            </Routes>

        </BrowserRouter>
    );
};

export default AppRouter;